import type { MasterProduct } from '@esf/shared';

/**
 * Thompson Aero Seating Vantage family master catalogue.
 * Generated from /thompson-aero-research/bom-*.json. Showcase product: VantageNOVA (MP-NOVA).
 */
export const demoMasterProducts: MasterProduct[] = [
  {
    id: "MP-NOVA",
    organisationId: "ORG-002",
    name: "VantageNOVA — next-generation Delta One Suite",
    sku: "MP-NOVA",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagenova.delta_a350_1000",
    gtin: "5012345010013",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Business-class lie-flat suite (Type A, 16g dynamic, reverse-herringbone, full-height privacy door, 100% PRM-accessible) · Thompson's first angled (herringbone / reverse-herringbone) twin-aisle product — a departure from the staggered Vantage DNA. Replaces VantageXL as Delta One on the A350-1000. Service entry 2027.",
    materialComposition: {
      totalWeightGrams: 85000,
      components: [
        {
          id: "MC-004",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 26520,
          percentageByWeight: 31.2,
          isRecycled: true,
          recycledContentPercent: 6,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 15810,
          percentageByWeight: 18.6,
          isRecycled: true,
          recycledContentPercent: 22,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-003",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 11220,
          percentageByWeight: 13.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 8500,
          percentageByWeight: 10.0,
          isRecycled: true,
          recycledContentPercent: 32,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 5568,
          percentageByWeight: 6.6,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 4420,
          percentageByWeight: 5.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 3825,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 3528,
          percentageByWeight: 4.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 2720,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 2040,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 850,
          percentageByWeight: 1.0,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.3,
      preConsumerRecycledPercent: 9.3,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-XL",
    organisationId: "ORG-002",
    name: "VantageXL — Delta One Suite",
    sku: "MP-XL",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagexl.delta_one_suite",
    gtin: "5012345010020",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Business-class lie-flat suite (Type A, 16g dynamic, direct-aisle-access, sliding privacy door) · First commercial business-class suite with a sliding privacy door; defined the modern business-class look. Broad fleet penetration across Delta, Virgin Atlantic, China Eastern, Lufthansa, Singapore Airlines.",
    materialComposition: {
      totalWeightGrams: 95000,
      components: [
        {
          id: "MC-003",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 36242,
          percentageByWeight: 38.1,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-004",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 11400,
          percentageByWeight: 12.0,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 9310,
          percentageByWeight: 9.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 7885,
          percentageByWeight: 8.3,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 6840,
          percentageByWeight: 7.2,
          isRecycled: true,
          recycledContentPercent: 28,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 6460,
          percentageByWeight: 6.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 6175,
          percentageByWeight: 6.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 3088,
          percentageByWeight: 3.3,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 3040,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 2280,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 2280,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 2.0,
      preConsumerRecycledPercent: 2.0,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent of TSO-C127c"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia loads (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic test + Head Injury Criterion (HIC) ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses — top-level seat rule"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage, tables — 9g forward)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during taxi/take-off/landing (interlock)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "12-second vertical Bunsen burn — all interior materials"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-SOLO",
    organisationId: "ORG-002",
    name: "VantageSOLO — Mint Suite (JetBlue)",
    sku: "MP-SOLO",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagesolo.jetblue_mint",
    gtin: "5012345010037",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Business-class lie-flat suite for narrow-body (Type A, 16g dynamic, direct-aisle-access, optional sliding door) · World's first fully-flat business-class seat for narrow-body aircraft. JetBlue Mint Suite + Mint Studio launched 2021 on A321LR; Mint Studio uses AIM Altitude bulkhead monument. Iberia is the actual launch customer for A321XLR (late 2024). VantageSOLO ID by Factorydesign (London).",
    materialComposition: {
      totalWeightGrams: 70000,
      components: [
        {
          id: "MC-003",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 26460,
          percentageByWeight: 37.8,
          isRecycled: true,
          recycledContentPercent: 7,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 15960,
          percentageByWeight: 22.8,
          isRecycled: true,
          recycledContentPercent: 18,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 7840,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-004",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 4340,
          percentageByWeight: 6.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 3150,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 3080,
          percentageByWeight: 4.4,
          isRecycled: true,
          recycledContentPercent: 73,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 2660,
          percentageByWeight: 3.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 2240,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 2240,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 1680,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 350,
          percentageByWeight: 0.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.8,
      preConsumerRecycledPercent: 9.8,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-XLFIRST",
    organisationId: "ORG-002",
    name: "VantageXL First — Virgin Atlantic Retreat Suite",
    sku: "MP-XLFIRST",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagexl_first.virgin_atlantic",
    gtin: "5012345010044",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "First-class density suite on the VantageXL platform (Type A, 16g dynamic, sliding privacy door) · First-class variant of VantageXL with a 32-inch IFE monitor, large table and suite doors. In service as the Virgin Atlantic 'Retreat Suite' on A330-900 — a front-row premium product within the wider Upper Class cabin.",
    materialComposition: {
      totalWeightGrams: 95000,
      components: [
        {
          id: "MC-003",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 36480,
          percentageByWeight: 38.4,
          isRecycled: true,
          recycledContentPercent: 7,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 22230,
          percentageByWeight: 23.4,
          isRecycled: true,
          recycledContentPercent: 17,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 10640,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-004",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 5890,
          percentageByWeight: 6.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 4275,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 3610,
          percentageByWeight: 3.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 3040,
          percentageByWeight: 3.2,
          isRecycled: true,
          recycledContentPercent: 100,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 3040,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 3040,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 2280,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 475,
          percentageByWeight: 0.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.8,
      preConsumerRecycledPercent: 9.8,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-XLPLUS",
    organisationId: "ORG-002",
    name: "VantageXL+ — A350 / B787 optimised",
    sku: "MP-XLPLUS",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagexlplus.china_southern",
    gtin: "5012345010051",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Business-class lie-flat suite (Type A, 16g dynamic, staggered direct-aisle-access, sliding privacy door) · Re-cut of VantageXL specifically optimised for A350 / B787 fuselage cross-sections — more usable space at the same density. Launched at AIX 2025 with China Southern, Edelweiss as first European customer. May have been renamed post-AIX 2025 — verify on Thompson's live site.",
    materialComposition: {
      totalWeightGrams: 80000,
      components: [
        {
          id: "MC-003",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 30160,
          percentageByWeight: 37.7,
          isRecycled: true,
          recycledContentPercent: 7,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 18720,
          percentageByWeight: 23.4,
          isRecycled: true,
          recycledContentPercent: 17,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 8960,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-004",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 5240,
          percentageByWeight: 6.6,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 3600,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 3320,
          percentageByWeight: 4.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 2560,
          percentageByWeight: 3.2,
          isRecycled: true,
          recycledContentPercent: 100,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 2560,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 2560,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 1920,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 400,
          percentageByWeight: 0.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.8,
      preConsumerRecycledPercent: 9.8,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-XLPLUSFIRST",
    organisationId: "ORG-002",
    name: "VantageXL+ First — widest suite yet",
    sku: "MP-XLPLUSFIRST",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagexlplus_first.aix2026",
    gtin: "5012345010068",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "First-class lie-flat suite on the XL+ platform (Type A, 16g dynamic, overhung sliding door) · Thompson's widest suite yet, revealed at AIX 2026. Aimed at airlines wanting genuine first-class on the XL+ platform alongside business class. Launch customer not publicly named.",
    materialComposition: {
      totalWeightGrams: 100000,
      components: [
        {
          id: "MC-004",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 38400,
          percentageByWeight: 38.4,
          isRecycled: true,
          recycledContentPercent: 7,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 16600,
          percentageByWeight: 16.6,
          isRecycled: true,
          recycledContentPercent: 25,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-003",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 11200,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 10000,
          percentageByWeight: 10.0,
          isRecycled: true,
          recycledContentPercent: 32,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 6200,
          percentageByWeight: 6.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 4500,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 3800,
          percentageByWeight: 3.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 3200,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 3200,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 2400,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 500,
          percentageByWeight: 0.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.8,
      preConsumerRecycledPercent: 9.8,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-NOVAFIRST",
    organisationId: "ORG-002",
    name: "VantageNOVA First — 'Star' shared-dining first-class",
    sku: "MP-NOVAFIRST",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantagenovafirst.aix2025",
    gtin: "5012345010075",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "First-class herringbone suite with 'Star' arrangement (Type A, 16g dynamic, full-height door) · First-class variant of VantageNOVA, launched AIX 2025. The 'Star' four-seat shared-dining arrangement is the signature feature. 2026 Crystal Cabin Award finalist. No public launch customer named.",
    materialComposition: {
      totalWeightGrams: 100000,
      components: [
        {
          id: "MC-004",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 38400,
          percentageByWeight: 38.4,
          isRecycled: true,
          recycledContentPercent: 7,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 16600,
          percentageByWeight: 16.6,
          isRecycled: true,
          recycledContentPercent: 25,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-003",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 11200,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 10000,
          percentageByWeight: 10.0,
          isRecycled: true,
          recycledContentPercent: 32,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 6200,
          percentageByWeight: 6.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 4500,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 3800,
          percentageByWeight: 3.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 3200,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Silicone",
          materialType: "Silicone",
          weightGrams: 3200,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 2400,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 500,
          percentageByWeight: 0.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 9.8,
      preConsumerRecycledPercent: 9.8,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-DUO",
    organisationId: "ORG-002",
    name: "VantageDUO — paired angled 'zero-G' recliner",
    sku: "MP-DUO",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantageduo.aix2022",
    gtin: "5012345010082",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.813",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Premium recliner — NOT lie-flat. Paired angled-towards-window seat with up to 130° shell recline. · Thompson's regional / short-haul / 'business-plus' product. NOT a fully-flat seat — distinct from the rest of the Vantage family. Optional pneumatic lumbar / massage and heating/cooling cushion. Targets the regional business-class gap left by the retirement of regional jet first-class. No headline launch customer publicly named.",
    materialComposition: {
      totalWeightGrams: 60000,
      components: [
        {
          id: "MC-004",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 18540,
          percentageByWeight: 30.9,
          isRecycled: true,
          recycledContentPercent: 8,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 9960,
          percentageByWeight: 16.6,
          isRecycled: true,
          recycledContentPercent: 25,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-003",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 6480,
          percentageByWeight: 10.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 5690,
          percentageByWeight: 9.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 4680,
          percentageByWeight: 7.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 3930,
          percentageByWeight: 6.6,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 3200,
          percentageByWeight: 5.3,
          isRecycled: true,
          recycledContentPercent: 100,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Polyurethane Foam",
          materialType: "Polyurethane Foam",
          weightGrams: 3200,
          percentageByWeight: 5.3,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 2880,
          percentageByWeight: 4.8,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 1440,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 11.9,
      preConsumerRecycledPercent: 11.9,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.813",
        certificateNumber: "FAR/CS 25.813",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency egress — privacy door must open during TTL (interlock-enforced)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  },
  {
    id: "MP-VANTAGE",
    organisationId: "ORG-002",
    name: "Vantage — staggered fully-flat business-class",
    sku: "MP-VANTAGE",
    version: 1,
    isActive: true,
    category: "seating",
    subcategory: "Aircraft Passenger Suite",
    model: "seat.vantage.showroom",
    gtin: "5012345010099",
    manufacturer: "Thompson Aero Seating Ltd",
    manufacturerCountry: "GB",
    materials: [
      "Aluminium 7075-T7351 / 6082",
      "Carbon Fibre Composite",
      "Polyurethane Foam",
      "Leather / Wool textile",
      "Lithium-ion (IFE backup cell)",
      "Copper wiring",
      "Electronics assemblies"
    ],
    certifications: [
      "TSO-C127c",
      "ETSO-C127c",
      "TSO-C39c",
      "FAR/CS 25.561",
      "FAR/CS 25.562",
      "FAR/CS 25.785",
      "FAR/CS 25.789",
      "FAR/CS 25.853(a)"
    ],
    carbonFootprint: 1100.0,
    recyclabilityScore: 78,
    expectedLifespan: 15,
    repairabilityScore: 7.5,
    description: "Business-class lie-flat (Type A, 16g dynamic, staggered direct-aisle-access, no privacy door) · The original staggered fully-flat business-class seat and the design DNA underneath every later Vantage-family product. Still in active production for both narrow-body (SAS, Aer Lingus, Thai, Hainan) and twin-aisle (Air Côte d'Ivoire) operators.",
    materialComposition: {
      totalWeightGrams: 65000,
      components: [
        {
          id: "MC-001",
          name: "Metal - Aluminium",
          materialType: "Metal - Aluminium",
          weightGrams: 18590,
          percentageByWeight: 28.6,
          isRecycled: true,
          recycledContentPercent: 14,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-003",
          name: "Composite / Other",
          materialType: "Composite / Other",
          weightGrams: 17225,
          percentageByWeight: 26.5,
          isRecycled: true,
          recycledContentPercent: 20,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-002",
          name: "Metal - Titanium",
          materialType: "Metal - Titanium",
          weightGrams: 7280,
          percentageByWeight: 11.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-005",
          name: "Leather",
          materialType: "Leather",
          weightGrams: 6078,
          percentageByWeight: 9.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-004",
          name: "Aramid Honeycomb Core",
          materialType: "Aramid Honeycomb Core",
          weightGrams: 4258,
          percentageByWeight: 6.6,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-007",
          name: "Electronics Assembly",
          materialType: "Electronics Assembly",
          weightGrams: 2925,
          percentageByWeight: 4.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-008",
          name: "Thermoplastic",
          materialType: "Thermoplastic",
          weightGrams: 2275,
          percentageByWeight: 3.5,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-010",
          name: "Carbon Fibre Composite",
          materialType: "Carbon Fibre Composite",
          weightGrams: 2080,
          percentageByWeight: 3.2,
          isRecycled: true,
          recycledContentPercent: 100,
          isPreConsumerRecycled: true,
          originCountry: "GB"
        },
        {
          id: "MC-011",
          name: "Polyurethane Foam",
          materialType: "Polyurethane Foam",
          weightGrams: 2080,
          percentageByWeight: 3.2,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-006",
          name: "Wool Textile",
          materialType: "Wool Textile",
          weightGrams: 1560,
          percentageByWeight: 2.4,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        },
        {
          id: "MC-009",
          name: "Metal - Steel",
          materialType: "Metal - Steel",
          weightGrams: 650,
          percentageByWeight: 1.0,
          isRecycled: false,
          isPreConsumerRecycled: false,
          originCountry: "GB"
        }
      ],
      totalRecycledContentPercent: 12.5,
      preConsumerRecycledPercent: 12.5,
      postConsumerRecycledPercent: 0,
      bioBasedContentPercent: 0,
      renewableContentPercent: 0,
      verificationBody: "Bureau Veritas UK (planned)",
      verificationDate: "2026-01-15"
    },
    carbonFootprintData: {
      totalKgCO2e: 1100.0,
      functionalUnit: "per seat-place over 15-year service life",
      phases: [
        {
          phase: "RAW_MATERIAL_ACQUISITION",
          kgCO2e: 374.0,
          percentageOfTotal: 34.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "MANUFACTURING",
          kgCO2e: 242.0,
          percentageOfTotal: 22.0,
          dataQuality: "PRIMARY"
        },
        {
          phase: "DISTRIBUTION",
          kgCO2e: 55.0,
          percentageOfTotal: 5.0,
          dataQuality: "SECONDARY"
        },
        {
          phase: "USE_PHASE",
          kgCO2e: 308.0,
          percentageOfTotal: 28.0,
          dataQuality: "ESTIMATED"
        },
        {
          phase: "END_OF_LIFE",
          kgCO2e: 121.0,
          percentageOfTotal: 11.0,
          dataQuality: "SECONDARY"
        }
      ],
      calculationMethodology: "ISO 14067:2018 (Thompson Aero internal LCA, programme estimate)",
      systemBoundary: "Cradle-to-grave",
      verificationBody: "Bureau Veritas UK (planned 2026)",
      verificationDate: "2026-06-30",
      dataQualityRating: 3
    },
    certificationsStructured: [
      {
        id: "CERT-001",
        type: "OTHER",
        name: "TSO-C127c",
        certificateNumber: "TSO-C127c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Whole-seat dynamic approval per SAE AS8049E (May 2025)"
      },
      {
        id: "CERT-002",
        type: "OTHER",
        name: "ETSO-C127c",
        certificateNumber: "ETSO-C127c",
        issuingBody: "EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "EASA equivalent"
      },
      {
        id: "CERT-003",
        type: "OTHER",
        name: "TSO-C39c",
        certificateNumber: "TSO-C39c",
        issuingBody: "FAA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Legacy 9g static — applies to non-dynamic load paths"
      },
      {
        id: "CERT-004",
        type: "OTHER",
        name: "FAR/CS 25.561",
        certificateNumber: "FAR/CS 25.561",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Emergency landing inertia (structural)"
      },
      {
        id: "CERT-005",
        type: "OTHER",
        name: "FAR/CS 25.562",
        certificateNumber: "FAR/CS 25.562",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Dynamic 16g test; HIC ≤ 1000"
      },
      {
        id: "CERT-006",
        type: "OTHER",
        name: "FAR/CS 25.785",
        certificateNumber: "FAR/CS 25.785",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Seats, safety belts and harnesses (top-level seat rule)"
      },
      {
        id: "CERT-007",
        type: "OTHER",
        name: "FAR/CS 25.789",
        certificateNumber: "FAR/CS 25.789",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Retention of items of mass (stowage / table)"
      },
      {
        id: "CERT-008",
        type: "OTHER",
        name: "FAR/CS 25.853(a)",
        certificateNumber: "FAR/CS 25.853(a)",
        issuingBody: "FAA / EASA",
        issueDate: "2025-06-01",
        expiryDate: "2030-06-01",
        scope: "Vertical Bunsen flammability (12-sec)"
      }
    ],
    endOfLifeData: {
      disassemblyInstructions: [
        {
          stepNumber: 1,
          instruction: "Disconnect 28V DC and seat-power harness at PSCU; isolate IFE Cat-6/HDMI.",
          toolsRequired: [
            "Insulated 6mm flat",
            "Wago lever-nut tool"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Electrical harness + PSCU",
          materialType: "Copper / Electronics",
          recyclingStream: "WEEE — electronics & cable",
          warningNotes: "Lock-out tag-out before unplugging."
        },
        {
          stepNumber: 2,
          instruction: "Remove IFE 24-inch OLED monitor and pivot arm.",
          toolsRequired: [
            "Torx T20",
            "Hex 4mm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "IFE display",
          materialType: "Electronics + Glass",
          recyclingStream: "WEEE — display"
        },
        {
          stepNumber: 3,
          instruction: "Unbolt privacy door and shroud assembly.",
          toolsRequired: [
            "Torx T30"
          ],
          estimatedTimeMinutes: 25,
          componentRemoved: "Privacy door + shroud",
          materialType: "Carbon Fibre Composite",
          recyclingStream: "CFRP recovery (pyrolysis or mechanical)"
        },
        {
          stepNumber: 4,
          instruction: "Remove cushion stack and dress covers; segregate leather from foam.",
          toolsRequired: [
            "Hand tools"
          ],
          estimatedTimeMinutes: 12,
          componentRemoved: "Cushion stack + dress cover",
          materialType: "PU foam + Leather/Wool",
          recyclingStream: "Energy recovery (foam); leather to specialist re-use"
        },
        {
          stepNumber: 5,
          instruction: "Remove actuators, gas struts and harness loom.",
          toolsRequired: [
            "Spanner 13/17mm",
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 20,
          componentRemoved: "Actuation assembly",
          materialType: "Electronics + Steel + Aluminium",
          recyclingStream: "WEEE + metal separation"
        },
        {
          stepNumber: 6,
          instruction: "Remove tray table and stowage compartments.",
          toolsRequired: [
            "Torx T25"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Tray + stowage",
          materialType: "Aluminium / Thermoplastic",
          recyclingStream: "Metal + plastic streams"
        },
        {
          stepNumber: 7,
          instruction: "Detach restraint (lap belt / inflatable belt assembly) for separate disposal.",
          toolsRequired: [
            "Hex 5mm"
          ],
          estimatedTimeMinutes: 8,
          componentRemoved: "Restraint assembly",
          materialType: "Textile + Metal",
          recyclingStream: "Manufacturer take-back (Schroth / AmSafe)",
          warningNotes: "If inflatable belt: depressurise and discharge initiator BEFORE removal."
        },
        {
          stepNumber: 8,
          instruction: "Lift trim & finish panels off the primary structure.",
          toolsRequired: [
            "Trim tools"
          ],
          estimatedTimeMinutes: 18,
          componentRemoved: "Trim panels",
          materialType: "Composite + Phenolic",
          recyclingStream: "Composite recovery / energy"
        },
        {
          stepNumber: 9,
          instruction: "Unbolt seat from seat track and lift primary structure.",
          toolsRequired: [
            "Torque wrench 30Nm"
          ],
          estimatedTimeMinutes: 15,
          componentRemoved: "Primary structure (spreader/beam/shell)",
          materialType: "Aluminium + CFRP",
          recyclingStream: "Aluminium closed-loop + CFRP recovery"
        }
      ],
      totalDisassemblyTimeMinutes: 148,
      nonDestructiveRemovalPossible: true,
      specialToolsRequired: [
        "Torque wrench 30Nm",
        "Insulated 6mm flat",
        "Trim tools"
      ],
      professionalDisassemblyRequired: true,
      recyclableMaterialsPercent: 78,
      recoverableEnergyPercent: 14,
      landfillPercent: 4,
      hazardousWastePercent: 4,
      recyclingFacilityRequirements: "Aerospace-certified processor with WEEE handling, Li-ion battery containment, and CFRP recovery capability.",
      hazardousComponentsWarning: "Lithium-ion seat backup cell and (if fitted) pyrotechnic restraint initiator must be removed by trained personnel.",
      takeBackSchemeAvailable: true,
      takeBackSchemeUrl: "https://www.thompsonaero.com/sustainability/take-back",
      takeBackSchemePhone: "+44 28 3839 8888"
    },
    hasBattery: true,
    batteryCapacityKwh: 0.05,
    createdAt: "2026-01-15T10:00:00.000Z",
    updatedAt: "2026-05-21T10:00:00.000Z"
  }
];
